import { createContext, useEffect, useState } from "react";
import { User, getAuth, onAuthStateChanged } from "firebase/auth";
import { app } from "firebaseApp";

interface AuthProps {
    children: React.ReactNode;
}

export const AuthContext = createContext({
    user: null as User | null,
});

export const AuthContextProvider = ({ children }: AuthProps) => {
    const [currentUser, setCurrentUser] = useState<User | null>(null);
    const auth = getAuth(app);
    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                setCurrentUser(user);
            } else {
                setCurrentUser(null);
            }
        });
    }, [auth]);
    return <AuthContext.Provider value={{ user: currentUser }}>{children}</AuthContext.Provider>;
};
